module.exports = __webpack_public_path__ + "static/poster-d53394099078cea6cc776ff8d9daacb7.png";